<template>
  <!-- eslint-disable vue/no-v-html -->
  <div
    class="has-text-danger has-text-centered is-size-6"
    v-html="error.description"
  />
  <!-- eslint-enable vue/no-v-html -->
</template>

<script>
export default {
  props: {
    error: {
      type: Object,
      required: true,
    },
  },
}
</script>
